
























import { defineComponent, computed } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import { usePropSync } from '~/composables/usePropSync';
export default defineComponent({
  components: {
    AppIcon,
  },
  props: {
    maxCount: {
      type: Number,
      default: Infinity,
    },
    minCount: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 0,
    },
    notIncrementable: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: String,
      default: 'text-base',
    },
    isSpBigButton: {
      type: Boolean,
      default: false,
    },
    isGiftSetting: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { syncedCount } = usePropSync(props, 'count');
    // ギフト設定画面の際は色を変える
    const activeClass = props.isGiftSetting ? 'border-Black60 text-Black60' : 'border-WineRed text-WineRed';
    const inActiveClass = 'border-Black10 text-Black10 pointer-events-none';

    const incrementable = computed(() => {
      if (props.notIncrementable) {
        return false;
      }
      return props.maxCount > syncedCount.value;
    });
    const decrementable = computed(() => syncedCount.value > props.minCount);
    const increment = () => {
      syncedCount.value++;
    };
    const decrement = () => {
      syncedCount.value--;
    };
    return { activeClass, inActiveClass, incrementable, decrementable, increment, decrement, syncedCount };
  },
});
